import React from 'react';
import { TableHead, TableRow } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import TableCellHeader from 'app/components/TableCellHeader';
import type { TableCellHeaderOnChangeArgs } from 'app/components/TableCellHeader';
import { TableCellStyled } from './ConnectionsTable.styles';
import type { ConnectionsTableSortState } from './useConnectionsTable';

type ConnectionsTableHeaderProps = {
  sortState: ConnectionsTableSortState;
  onSortChange: (args: TableCellHeaderOnChangeArgs) => void;
};

export const ConnectionsTableHeader = ({ sortState, onSortChange }: ConnectionsTableHeaderProps) => (
  <TableHead>
    <TableRow>
      <TableCellHeader
        name="connectionName"
        direction={sortState.connectionName}
        arrowPosition="right"
        onChange={onSortChange}
        sx={{ minWidth: 200, width: '25%' }}
      >
        <FormattedMessage id="connections.connectionName" />
      </TableCellHeader>
      <TableCellHeader name="logsCount" direction={sortState.logsCount} arrowPosition="right" onChange={onSortChange}>
        <FormattedMessage id="connections.numberOfLogMessages" />
      </TableCellHeader>
      <TableCellHeader
        name="eventsCount"
        direction={sortState.eventsCount}
        arrowPosition="right"
        onChange={onSortChange}
      >
        <FormattedMessage id="connections.numberOfEvents" />
      </TableCellHeader>
      <TableCellStyled>
        <FormattedMessage id="connections.packages" />
      </TableCellStyled>
      <TableCellStyled>
        <FormattedMessage id="connection.latestRun" />
      </TableCellStyled>
      <TableCellStyled>
        <FormattedMessage id="connections.createdAt" />
      </TableCellStyled>
    </TableRow>
  </TableHead>
);
